import React from 'react';
import img from './img/logo.png';

const App = () => {
    return (
      <div className="relative min-h-screen flex flex-col items-center justify-center bg-gray-100 overflow-hidden bg-gradient-to-r from-gray-200 to-green-500">

       <img
        src={img}
        alt="background left"
        className="absolute right-0 top-0 object-right h-full w-full object-contain opacity-30"
      />
          <h1 className="text-8xl font-bold text-white mb-4">DE OLIIMAGE COMPANY</h1>
        <div className="relative z-10 text-center p-8  rounded-lg shadow-lg max-w-md w-full">
            <h1 className="text-4xl font-bold text-white items-left">Innovative Solutions for Sustainable Growth</h1>
</div>
        </div>
    );
};

export default App;